// extracted by mini-css-extract-plugin
module.exports = {"sideBar":"SideBar_sideBar__2aVGc","submenuItem":"SideBar_submenuItem__2wV3I","title":"SideBar_title__2Gy8r","list":"SideBar_list__1U4PE","menuItem":"SideBar_menuItem__3K-Bj"};